import * as RadixSelect from '@radix-ui/react-select'
import { forwardRef, useContext } from 'react'
import { ContentPrimitive } from '../primitives'
import { SelectContext } from '../SelectContext'

export interface ContentProps extends RadixSelect.SelectContentProps {}

export const Content = forwardRef<HTMLDivElement, ContentProps>(
  ({ children, position = 'popper', ...props }, ref) => {
    const { variant } = useContext(SelectContext)

    return (
      <ContentPrimitive {...props} position={position} variant={variant} ref={ref}>
        {children}
      </ContentPrimitive>
    )
  }
)
